var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_headphone",
    "data-name": "vuesax/outline/headphone",
    transform: "translate(-620 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headphone",
    transform: "translate(620 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.421,16.942A3.468,3.468,0,0,1,0,13.522V8.645A8.437,8.437,0,0,1,8.472,0a8.56,8.56,0,0,1,8.55,8.55v4.877a3.426,3.426,0,0,1-3.42,3.42,3.468,3.468,0,0,1-3.42-3.42V11.2a2.05,2.05,0,0,1,4.1,0v2.4a.594.594,0,0,1-1.187,0V11.2a.863.863,0,0,0-1.726,0v2.225a2.233,2.233,0,0,0,4.465,0V8.55A7.369,7.369,0,0,0,8.472,1.188,7.248,7.248,0,0,0,1.189,8.629v4.892a2.261,2.261,0,0,0,2.233,2.233,2.261,2.261,0,0,0,2.233-2.233V11.3a.863.863,0,1,0-1.726,0v2.312a.594.594,0,0,1-1.188,0V11.3a2.05,2.05,0,1,1,4.1,0v2.225A3.468,3.468,0,0,1,3.421,16.942Z",
    transform: "translate(0.988 1.029)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport2);
export default __webpack_public_path__ + "static/media/support2.40d0e94da423714932f7eb0cdfac3083.svg";
export { ForwardRef as ReactComponent };